var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKasaFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146 48",
    style: {
      enableBackground: "new 0 0 146 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,24.5l-7.8,7.9v11.1H0.5v-43h6.1v24.1L29.7,0.5h7L18.5,19.8L38,43.5h-7.1L14.3,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,40.1l2.4-4.6c2.8,1.9,7.1,3.3,11.3,3.3c5.5,0,7.6-1.7,7.6-4.5c0-7.3-20.4-1-20.4-14 c0-5.9,5.2-9.7,13.5-9.7c4.2,0,9,1.1,11.8,2.9l-2.5,4.6c-2.9-1.9-6.1-2.6-9.3-2.6c-5.1,0-7.6,1.9-7.6,4.5c0,7.7,20.4,1.4,20.4,14.1 c0,5.9-5.3,9.6-14,9.6C90.4,43.9,85.1,42.2,82.4,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.5,23.8v19.7h-5.6v-4.3c-1.9,3-5.6,4.6-10.7,4.6c-7.4,0-11.9-4-11.9-9.6c0-5.2,3.3-9.5,13-9.5h9.3v-1.1 c0-5-2.9-7.8-8.6-7.8c-3.8,0-7.7,1.4-10.3,3.5l-2.4-4.5c3.3-2.7,8.1-4.2,13.3-4.2C140.6,10.6,145.5,15,145.5,23.8z M139.7,33.5 v-4.6h-9c-5.8,0-7.5,2.3-7.5,5c0,3.2,2.7,5.2,7.1,5.2C134.7,39.3,138.3,37.4,139.7,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,24.3l-15.1-8.8l-8.4-4.9L42,25.1l0.1,13.6l15,8.8l1.5-0.9V33.8l6.7-11.9l6.9,4v12.8l1.5-0.9V24.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKasaFooter);
export default __webpack_public_path__ + "static/media/logo-kasa_footer.8edfd706ade41e67a1a04bb5cfcd30d3.svg";
export { ForwardRef as ReactComponent };